<template>
  <el-form
    ref="ruleForm"
    :model="formData"
    label-width="0"
    class="demo-ruleForm error-form"
    size="small"
    :rules="rules"
  >
    <el-table
      :data="formData.arr"
      border
    >
      <!-- 费用类型 -->
      <el-table-column prop="feeTypeCode" width="200">
        <template slot="header">
          <div>
            <span style="color: red;">*</span>
            <span>{{ $t('basicData.ExpenseType') }}</span>
          </div>
        </template>
        <template slot-scope="scope">
          <el-form-item
            :prop="`arr.${scope.$index}.feeTypeCode`"
            :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
          >
            <el-select
              v-model="scope.row.feeTypeCode"
              :placeholder="$t('basicData.PleaseSelect')"
              style="width: 100%;"
            >
              <el-option
                v-for="item in feeTypeList"
                :key="item.id"
                :label="item.displayName + '(' + item.code + ')'"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </template>
      </el-table-column>

      <!-- 重量开始(KM) 不包含 -->
      <el-table-column min-width="200">
        <template slot="header">
          <div>
            <span style="color: red;">*</span>
            <span>{{ $t('receivablePayable.weightStart') }}</span>
          </div>
        </template>
        <template slot-scope="scope">
          <el-form-item
            :prop="`arr.${scope.$index}.startWeight`"
            :rules="{
              required: true,
              negative: '',
              suffix: 3,
              negative1: 1,
              package: scope.row.endWeight,
              validator: weightType,
              trigger: ['blur', 'change']
            }"
          >
            <el-input v-model="scope.row.startWeight" />
          </el-form-item>
        </template>
      </el-table-column>

      <!-- 重量结束(KM) 包含 -->
      <el-table-column min-width="200">
        <template slot="header">
          <div>
            <span style="color: red;">*</span>
            <span>{{ $t('receivablePayable.weightEndInclusive') }}</span>
          </div>
        </template>
        <template slot-scope="scope">
          <el-form-item
            :prop="`arr.${scope.$index}.endWeight`"
            :rules="{
              required: true,
              negative: '',
              suffix: 3,
              negative1: 2,
              package: scope.row.startWeight,
              validator: weightType,
              trigger: ['blur', 'change']
            }"
          >
            <el-input v-model="scope.row.endWeight" />
          </el-form-item>
        </template>
      </el-table-column>

      <!-- 区间价格 -->
      <el-table-column min-width="180">
        <template slot="header">
          <div>
            <span style="color: red;">*</span>
            <span>{{ $t('receivablePayable.priceRange') }}</span>
          </div>
        </template>
        <template slot-scope="scope">
          <div>
            <el-form-item
              :prop="`arr.${scope.$index}.price`"
              :rules="{ required: true, suffix: 3, negative: '', validator: weightType, trigger: ['blur', 'change'] }"
            >
              <el-input v-model="scope.row.price" />
            </el-form-item>
          </div>
        </template>
      </el-table-column>

      <el-table-column :label="$t('basicData.operate')" fixed="right" width="100">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="danger"
            @click="handleDel(scope.$index)"
          >{{ $t('basicData.Delete') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-form>
</template>

<script>
import { cloneDeep } from 'lodash-es';

/** @typedef {import('./types').TTableRow} TTableRow */

export default {
  name: '',

  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    feeTypeList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },

  data() {
    // 校验
    const weightType = (rule, value, callback) => {
      const reg = new RegExp('(^' + rule.negative + '[1-9]\\d*(\\.\\d{1,' + rule.suffix + '})?$)|(^' + rule.negative + '0(\\.\\d{1,' + rule.suffix + '})?$)');
      const { required } = rule;
      if (!required) {
        // 非必填
        if (value !== null && value !== '' && value !== undefined) {
          if (!reg.test(value)) {
            this.adopt = false;
            return callback(new Error(this.$i18n.t('basicData.IncorrectFormatting'))); // '格式不正确'
          } else {
            this.adopt = true;
            if (rule.package !== null && rule.package !== '' && rule.package !== undefined) {
              if (rule.negative1 === 2) {
                if (parseFloat(value) <= parseFloat(rule.package)) {
                  console.log(parseFloat(value), parseFloat(rule.package), parseFloat(value) <= parseFloat(rule.package));
                  return callback(new Error(this.$i18n.t('basicData.MustGreaterThanStartingValue'))); // 必须大于起始值
                } else if (parseFloat(value) <= 0) {
                  return callback(new Error(this.$i18n.t('basicData.MustBeGreaterThan0'))); // 必须大于0
                }
              } else {
                if (parseFloat(value) >= parseFloat(rule.package)) {
                  return callback(new Error(this.$i18n.t('basicData.MustLessThanEndValue'))); // 必须小于结束值
                } else {
                  return callback();
                }
              }
            }
            return callback();
          }
        } else {
          return callback();
        }
      } else {
        if (value !== null && value !== '' && value !== undefined) {
          if (!reg.test(value)) {
            this.adopt = false;
            return callback(new Error(this.$i18n.t('basicData.IncorrectFormatting'))); // '格式不正确'
          } else {
            this.adopt = true;
            if (rule.negative1 === 2) {
              if (parseFloat(value) <= parseFloat(rule.package)) {
                console.log(parseFloat(value), parseFloat(rule.package), parseFloat(value) <= parseFloat(rule.package), '//////////////');
                return callback(new Error(this.$i18n.t('basicData.MustGreaterThanStartingValue'))); // 必须大于起始值
              } else if (parseFloat(value) <= 0) {
                return callback(new Error(this.$i18n.t('basicData.MustBeGreaterThan0'))); // 必须大于0
              }
            } else {
              if (parseFloat(value) >= parseFloat(rule.package)) {
                return callback(new Error(this.$i18n.t('basicData.MustLessThanEndValue'))); // 必须小于结束值
              } else {
                return callback();
              }
            }
            return callback();
          }
        } else {
          this.adopt = false;
          return callback(this.$i18n.t('basicData.CannotBeEmpty')); // '不能为空'
        }
      }
    };

    return {
      formData: {
        /** @type {TTableRow[]} */
        arr: []
      },

      rules: {
        feeTypeCode: [
          { required: true, message: this.$i18n.t('GlobalSetObj.pleaseChoose'), trigger: 'blur' }
        ],
        price: [
          { required: true, message: this.$i18n.t('GlobalSetObj.pleaseInput'), trigger: 'blur' }
        ],

        endWeight: [
          { required: true, message: this.$i18n.t('GlobalSetObj.pleaseInput'), trigger: 'blur' }
        ],
        startWeight: [
          { required: true, message: this.$i18n.t('GlobalSetObj.pleaseInput'), trigger: 'blur' }
        ]
      },

      weightType
    };
  },

  watch: {
    'tableData': {
      handler(val, oldVal) {
        // console.log('子组件监听', JSON.stringify(val), JSON.stringify(oldVal));
        if (oldVal === undefined) {
          // 第一次赋值
          this.formData.arr = [];
          return;
        }

        if (val.length === 0 && oldVal.length === 0) {
          return;
        }

        // 新的值与旧的值一样
        if (JSON.stringify(val) === JSON.stringify(this.formData.arr)) {
          // console.log('新的值与旧的值一样');
          return;
        }
        // console.log(123987, val);
        this.formData.arr = cloneDeep(this.tableData);
        // this.formData.arr.push(val);
      },
      immediate: true
    },

    // 将数据传给父组件
    formData: {

      handler(val, oldVal) {
        // console.log('子组件提交');
        if (!oldVal || !val) {
          return;
        }
        // console.log('父元素提交', val.arr);
        this.$emit('change', val.arr);
      },
      deep: true
      // immediate: true
    }
  },

  created() {

  },

  methods: {
    // 提交校验
    submitForm() {
      return this.$refs['ruleForm'].validate().then(() => {
        return true;
      }).catch(res => {
        return false;
      });
    },

    // 删除
    handleDel(index) {
      this.formData.arr.splice(index, 1);
    }
  }

};
</script>

<style  scoped>
.demo-ruleForm /deep/ .el-form-item__error {
  position: static !important;
}
</style>
